/**
 * GullyLabs — Doran Product Reviews Config Override
 * 
 * Doran renders inside srcdoc iframes. Its deferred SDK (pr-sdk.js)
 * reads window.$prDoranInit to determine colors, filters, etc.
 * This script runs INLINE (not deferred) at the end of <body>,
 * so it executes AFTER Doran's inline config scripts but BEFORE
 * the deferred SDK picks up the config. This lets us override
 * colors, disable filters, and inject custom CSS natively.
 */
(function () {
    'use strict';

    var BLUE = '#2563EB';
    var BLUE_DARK = '#1d4ed8';
    var WHITE = '#ffffff';

    // Custom CSS to inject into the Doran widget via their config
    var CUSTOM_CSS = [
        '/* GullyLabs overrides */',
        'body, .frame-root { background-color: #ffffff !important; }',
        'button { border-radius: 0 !important; }',
        'a { color: ' + BLUE + ' !important; }',
        '[class*="date" i], [class*="time" i] { color: #9CA3AF !important; }',
        'hr { border-color: #e5e7eb !important; }',
        'input, textarea { background: #fff !important; color: #1a1a1a !important; border: 1px solid #d1d5db !important; border-radius: 0 !important; }',
        'input:focus, textarea:focus { border-color: ' + BLUE + ' !important; }',
    ].join('\n');

    function overrideConfig() {
        if (!window.$prDoranInit) return;

        if (window.$prDoranInit.productWidget) {
            window.$prDoranInit.productWidget.ratingIconColor = BLUE;
            window.$prDoranInit.productWidget.buttonBackgroundColor = BLUE;
            window.$prDoranInit.productWidget.buttonTextColor = WHITE;
            window.$prDoranInit.productWidget.isDisplayFilters = false;
            window.$prDoranInit.productWidget.customCSS = CUSTOM_CSS;
            window.$prDoranInit.productWidget.isDarkMode = false;
            window.$prDoranInit.productWidget.reviewsPerPage = 3;
        }

        if (window.$prDoranInit.ratingWidget) {
            window.$prDoranInit.ratingWidget.ratingIconColor = BLUE;
            window.$prDoranInit.ratingWidget.isDarkMode = false;
            if (!window.$prDoranInit.ratingWidget.customCSS) {
                window.$prDoranInit.ratingWidget.customCSS = '';
            }
        }

        if (window.$prDoranInit.ratingBadgeWidget) {
            window.$prDoranInit.ratingBadgeWidget.ratingIconColor = BLUE;
            window.$prDoranInit.ratingBadgeWidget.isDarkMode = false;
        }

        if (window.$prDoranInit.ratingWidgetReview) {
            for (var key in window.$prDoranInit.ratingWidgetReview) {
                if (window.$prDoranInit.ratingWidgetReview.hasOwnProperty(key)) {
                    window.$prDoranInit.ratingWidgetReview[key].isDarkMode = false;
                }
            }
        }
    }

    overrideConfig();

    // Inject CSS into iframes after they render
    function injectIntoIframes() {
        var iframes = document.querySelectorAll('.shopify-app-block iframe');
        iframes.forEach(function (iframe) {
            try {
                var doc = iframe.contentDocument || iframe.contentWindow.document;
                if (doc && doc.head && !doc.querySelector('#gully-override')) {
                    var style = doc.createElement('style');
                    style.id = 'gully-override';
                    style.textContent = CUSTOM_CSS;
                    doc.head.appendChild(style);
                }
            } catch (e) {
                // Cross-origin or not ready yet
            }
        });
    }

    // ======================================================
    // REVIEW LIMIT: Show only ~3 reviews via CSS clipping
    // Does NOT move the iframe in the DOM (which would break it).
    // Instead, applies max-height + overflow:hidden on the
    // existing parent container and adds a button after it.
    // ======================================================
    var isMobile = window.innerWidth < 750;
    var COLLAPSED_HEIGHT = isMobile ? 1400 : 900; // mobile needs more height due to stacked layout
    var limitApplied = false;

    function setupReviewLimit() {
        if (limitApplied) return;

        var appBlocks = document.querySelectorAll('.shopify-app-block');
        for (var i = 0; i < appBlocks.length; i++) {
            var block = appBlocks[i];
            var iframe = block.querySelector('iframe');
            if (!iframe) continue;

            // Skip small iframes (rating stars widgets are tiny)
            var h = iframe.offsetHeight || iframe.clientHeight;
            if (h < 300) continue;

            // This is the large review widget iframe — apply clipping
            // Do NOT wrap or move the iframe; apply styles to its parent
            block.style.maxHeight = COLLAPSED_HEIGHT + 'px';
            block.style.overflow = 'hidden';
            block.style.position = 'relative';
            block.style.transition = 'max-height 0.5s ease';

            // Add gradient fade overlay
            var fade = document.createElement('div');
            fade.id = 'gully-review-fade';
            fade.style.cssText = 'position:absolute;bottom:0;left:0;right:0;height:80px;background:linear-gradient(transparent,#ffffff);pointer-events:none;z-index:2;';
            block.appendChild(fade);

            // Add "View More Reviews" button AFTER the block
            var btn = document.createElement('button');
            btn.id = 'gully-review-toggle';
            btn.textContent = 'View More Reviews';
            btn.style.cssText = [
                'display:block',
                'padding:12px 32px',
                'margin:20px auto',
                'background-color:' + BLUE,
                'color:#ffffff',
                'border:none',
                'border-radius:6px',
                'font-size:14px',
                'font-weight:600',
                'cursor:pointer',
                'text-align:center',
                'font-family:Inter,sans-serif',
                'transition:background-color 0.2s ease,transform 0.2s ease',
                'letter-spacing:0.3px',
            ].join(';') + ';';

            block.parentNode.insertBefore(btn, block.nextSibling);

            btn.addEventListener('mouseenter', function () {
                this.style.backgroundColor = BLUE_DARK;
                this.style.transform = 'translateY(-1px)';
            });
            btn.addEventListener('mouseleave', function () {
                this.style.backgroundColor = BLUE;
                this.style.transform = 'translateY(0)';
            });

            // Use closure to capture block, fade, btn
            (function (theBlock, theFade, theBtn) {
                var expanded = false;
                theBtn.addEventListener('click', function () {
                    if (!expanded) {
                        theBlock.style.maxHeight = 'none';
                        theFade.style.display = 'none';
                        theBtn.textContent = 'Show Less';
                        expanded = true;
                    } else {
                        theBlock.style.maxHeight = COLLAPSED_HEIGHT + 'px';
                        theFade.style.display = '';
                        theBtn.textContent = 'View More Reviews';
                        expanded = false;
                        theBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            })(block, fade, btn);

            limitApplied = true;
            break; // Only apply to the first large review iframe
        }
    }

    // Watch for DOM changes
    function startObserving() {
        if (!document.body) {
            setTimeout(startObserving, 50);
            return;
        }
        var observer = new MutationObserver(function () {
            injectIntoIframes();
            setupReviewLimit();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(function () { injectIntoIframes(); setupReviewLimit(); }, 1000);
            setTimeout(function () { injectIntoIframes(); setupReviewLimit(); }, 3000);
            setTimeout(function () { injectIntoIframes(); setupReviewLimit(); }, 6000);
            startObserving();
        });
    } else {
        setTimeout(function () { injectIntoIframes(); setupReviewLimit(); }, 1000);
        setTimeout(function () { injectIntoIframes(); setupReviewLimit(); }, 3000);
        setTimeout(function () { injectIntoIframes(); setupReviewLimit(); }, 6000);
        startObserving();
    }
})();
